import styled from 'styled-components'
import { compose, typography, color, background } from 'styled-system'

const SimpleTableRow = styled.tr`
  ${compose(typography, color, background)}
`

export default SimpleTableRow
